<template>
    <div class="reply-img-item">
        <div class="img" :style="getImgStyle">
            <MaskChecked v-if="item.id === selected.id" />
            <div v-if="item.imgLoadError" class="error-msg">图片加载失败</div>
        </div>
    </div>
</template>

<script>
import MaskChecked from './components/mask-checked';

export default {
    name: 'ImgItem',
    components: {
        MaskChecked
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        selected: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        getImgStyle() {
            return (!this.item.imgLoadError && `background-image: url("${this.item.showUrl}");`) || '';
        }
    }
};
</script>

<style>
.reply-img-item {
    position: relative;
    display: table-cell;
    overflow: hidden;
    margin: 1px;
    width: 130px;
    height: 130px;
    text-align: center;
    vertical-align: middle;
    border: 2px solid transparent;
}

.reply-img-item .img {
    width: 100%;
    height: 100%;
    background-position: 50% 50%;
    background-size: cover;
}

.reply-img-item .error-msg {
    position: absolute;
    top: 90px;
    width: 100%;
    font-size: 14px;
    text-align: center;
    color: #b4b7bf;
}
</style>
